__turbopack_context__.v({
  "lc-loading": "Loading-module__ijmVSa__lc-loading",
});
